import Form from "./base"
import PathObject from "../objects/path"
import pathRounding from "@/signomatic/util/path_rounding"
import type { DrawableMixin } from "../objects/drawable_mixin"

export default class TriangleForm extends Form {
  protected path(width: number, height: number, rounding?: number) {
    rounding = rounding ? rounding : 0

    const [side, rest] = this.snappableCommands(width, height)
    const cmds = side.concat(rest)

    if (rounding > 0) {
      const cmds = side
      cmds.push(rest[1], this.pathClose())

      return this.scaleToSize(new PathObject(pathRounding(cmds.join(" "), rounding), this.defaultParams), width, height)
    }

    if (this.signType == "solid_plastic_sign") {
      return new PathObject(this.joinedLineCommands(width, height).join(""), this.defaultParams)
    }

    return new PathObject(cmds.join(""), this.defaultParams)
  }

  protected snappablePaths(width: number, height: number): [DrawableMixin, DrawableMixin] {
    const [side, rest] = this.snappableCommands(width, height)

    return [new PathObject(side.join(""), this.defaultParams), new PathObject(rest.join(""), this.defaultParams)]
  }

  private snappableCommands(width: number, height: number): [string[], string[]] {
    const side = [this.pathMoveTo(width / 2, height / 2)]
    side.push(this.pathLineToAbs(-(width / 2), height / 2))

    const rest = [this.pathMoveTo(-(width / 2), height / 2)]

    rest.push(this.pathLineToAbs(0, -(height / 2)))
    rest.push(this.pathLineToAbs(width / 2, height / 2))

    return [side, rest]
  }

  private joinedLineCommands(width: number, height: number): string[] {
    const cmds = [this.pathMoveTo(width / 2, height / 2)]

    cmds.push(this.pathLineToAbs(-(width / 2), height / 2))
    cmds.push(this.pathLineToAbs(0, -(height / 2)))
    cmds.push(this.pathClose())

    return cmds
  }

  protected get baseRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  protected get cutlineRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  private calcRounding() {
    const { widthPx, heightPx, material } = this.state

    if (
      !["magnetic_sign", "forex_sign", "solid_plastic_sign", "ecoboard"].includes(this.signType) &&
      !(this.signType === "double_sided_sign" && ["ecoboard", "plastic"].includes(material))
    ) {
      return Math.min(Math.min(widthPx, heightPx) / 100, 10)
    }

    return 0
  }
}
